
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Dashboard from "../pages/dashboard/page";
import Entry from "../pages/entry/page";
import Ledger from "../pages/ledger/page";
import Reports from "../pages/reports/page";
import Customers from "../pages/customers/page";
import Settings from "../pages/settings/page";
import Submission from "../pages/submission/page";
import Finance from "../pages/finance/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Dashboard />,
  },
  {
    path: "/entry",
    element: <Entry />,
  },
  {
    path: "/ledger",
    element: <Ledger />,
  },
  {
    path: "/reports",
    element: <Reports />,
  },
  {
    path: "/finance",
    element: <Finance />,
  },
  {
    path: "/submission",
    element: <Submission />,
  },
  {
    path: "/customers",
    element: <Customers />,
  },
  {
    path: "/settings",
    element: <Settings />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
